import isUndefined from "lodash/isUndefined";

import { createReducer } from "../../../generic/redux/createReducer";
import { pairActionTypeToReducer } from "../../../generic/redux/TypedRedux";

import type { ClosePane, OpenPane } from "./LayoutActions";
import { CLOSE_PANE, OPEN_PANE } from "./LayoutActionTypes";
import { type LayoutState, initialLayoutState } from "./LayoutState";

function openPaneReducer(state: LayoutState, action: OpenPane): LayoutState {
	const { location, name } = action;
	return {
		...state,
		activePanes: {
			...state.activePanes,
			[location]: name,
		},
	};
}

const closePaneReducer = (state: LayoutState, { location, name }: ClosePane): LayoutState => {
	const currentPane = state.activePanes[location];
	return {
		...state,
		activePanes: {
			...state.activePanes,
			[location]: isUndefined(name) || currentPane === name ? undefined : currentPane,
		},
	};
};

export default createReducer<LayoutState>(initialLayoutState, {
	...pairActionTypeToReducer(CLOSE_PANE, closePaneReducer),
	...pairActionTypeToReducer(OPEN_PANE, openPaneReducer),
});
